import * as IO from "../../helpers/io.js";
//
// Model.
//
export var CredentialsAlgorithm;
(function (CredentialsAlgorithm) {
    CredentialsAlgorithm["ED_25519"] = "ed25519";
})(CredentialsAlgorithm || (CredentialsAlgorithm = {}));
export const RCredentialsAlgorithm = IO.weakEnumeration(CredentialsAlgorithm);
